<template>
  <App>
    <NuxtPage />
  </App>
</template>
